Greenmile.Survey.Sidebar.EntityGridPreviewDnD = function (grid, collection, question) {

  grid.setSelectionModel(new Slick.RowSelectionModel());
  if (grid.gmPlugin) {
    grid.unregisterPlugin(grid.gmPlugin);
  }

  var moveRowsPlugin = new Slick.RowMoveManager({ cancelEditOnDrag: true });

  moveRowsPlugin.onMoveRows.subscribe(function (question, e, args) {

    var dataView = grid.getData();
    var data = dataView.data;
    var rowPosition = args.rows[0];
    var position = args.insertBefore;
    var row = data.slice(rowPosition, rowPosition + 1)[0];

    data = data.reduce(function(newData, item, index) {
      if (index === position) {
        newData.push(row);
      }
      if (index !== rowPosition) {
        newData.push(item);
      }
      return newData;
    }, []);

    if (position >= data.length) {
      data.push(row);
    }

    dataView.beginUpdate();
    dataView.setData(data);
    dataView.endUpdate();

    grid.resetActiveCell();
    grid.setData(dataView);
    grid.render();

    var entityRestriction = JSON.parse(question.entityRestriction);
    var newOrder = data.map(function(item) {
      return String(item.idOfObject);
    });
    entityRestriction.criteriaChain[0].and[0].in = newOrder;
    question.entityRestriction = JSON.stringify(entityRestriction);

  }.bind(this, question));

  grid.gmPlugin = moveRowsPlugin;
  grid.registerPlugin(moveRowsPlugin);

  grid.onDragInit.subscribe(function (e, dd) {
    e.stopImmediatePropagation();
  });

  $.drop({mode: "mouse"});

};
